import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { LiturgyType } from '../../services/liturgy-type.service';
import { LectionaryItem } from '../../services/lectionary-item.service';
import { LectionaryItemType } from '../../services/lectionary-item-type.service';
import { MatDialog } from '@angular/material/dialog';
import { LiturgyTypeLectionaryItemTypeDisplayOrderEditComponent } from '../liturgy-type-lectionary-item-type-display-order-edit/liturgy-type-lectionary-item-type-display-order-edit.component';
import { LiturgyTypeLectionaryItemTypeDisplayOrder } from 'app/objects';

@Component({
  selector: 'app-liturgy-type-lectionary-item-type-display-order',
  templateUrl: './liturgy-type-lectionary-item-type-display-order.component.html',
  styleUrls: ['./liturgy-type-lectionary-item-type-display-order.component.css']
})
export class LiturgyTypeLectionaryItemTypeDisplayOrderComponent implements OnInit {

  public isLoading: Boolean;
  public data: LiturgyTypeLectionaryItemTypeDisplayOrder[];

  constructor(
    public apiSvc: ApiService,
    public dialog: MatDialog
    ) { }

  ngOnInit() {
    this.loadElements();
  }

  private loadElements() {
    this.isLoading = true;
    this.apiSvc.get("api/LiturgyTypeLectionaryItemTypeDisplayOrder/", null).subscribe(
      (data: LiturgyTypeLectionaryItemTypeDisplayOrder[]) => {
        this.data = data;
        console.log(this.data);
        this.isLoading = false;
      },
      (err) => {
        console.log("error", err);
        this.isLoading = false;
      }
   );
  }

  public add() {

    var modal = this.dialog.open(LiturgyTypeLectionaryItemTypeDisplayOrderEditComponent); 
    modal.componentInstance.setNew();

    modal.afterClosed().subscribe(() => {
      console.log("modal closed");
  
     this.loadElements();
    });
 
  }

  public edit(model: LiturgyTypeLectionaryItemTypeDisplayOrder) {

    console.log("EDIT", model);

    var modal = this.dialog.open(LiturgyTypeLectionaryItemTypeDisplayOrderEditComponent);
    modal.componentInstance.setModel(model);
  
    modal.afterClosed().subscribe(() => { 
      console.log("modal closed");
  
     this.loadElements();
    });

  }


  public delete(model: LiturgyTypeLectionaryItemTypeDisplayOrder) {

    console.log("DELETE", model);

    if (confirm("Are you sure you want to delete this entity?") == false) return;

    this.apiSvc.post("api/LiturgyTypeLectionaryItemTypeDisplayOrder/delete", {id: model.Id}).subscribe(
      () => { 
        this.loadElements();
      },
      (err) => {
        console.log("error", err);
        this.isLoading = false;
      }
   );

  }
 
}



